import { ATTESTATION_STATUT_OPTIONS } from '@common/config';
import { SetUtils } from '@common/utils';
import React from 'react';
import { DropdownSelectionFilter } from '../DropdownSelectionFilter';

export const StatutAttestationFilter = ({
                                          statut,
                                          onStatutChange,
                                          withPartielleValue,
                                        }: StatutAttestationFilterProps) => {
  const options = (withPartielleValue)
    ? [...ATTESTATION_STATUT_OPTIONS, { label: 'Partielle', value: 'PARTIELLE' }]
    : ATTESTATION_STATUT_OPTIONS;

  return (
    <DropdownSelectionFilter selection={new Set((statut) ? [statut] : [])}
                             onSelectionChange={(selection) => onStatutChange(SetUtils.takeFirst(selection))}
                             buttonLabel="statut de l'attestation"
                             options={options}
                             tooltip="Filtrer par statut de l'attestation" />
  );
};

interface StatutAttestationFilterProps {
  statut: string | null;
  onStatutChange: (statut: string) => void;
  withPartielleValue?: boolean;
}